import { render, staticRenderFns } from "./Revenuerecord.vue?vue&type=template&id=1490f69e&scoped=true"
import script from "./Revenuerecord.vue?vue&type=script&lang=js"
export * from "./Revenuerecord.vue?vue&type=script&lang=js"
import style0 from "./Revenuerecord.vue?vue&type=style&index=0&id=1490f69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490f69e",
  null
  
)

export default component.exports